export const PASTEL_COLORS = [
  { bg: '#FAE8D4', border: '#E6C5A0' },  // warm sand
  { bg: '#E8DFD0', border: '#C9B99E' },  // parchment
  { bg: '#D4E8D9', border: '#9CC5A6' },  // sage/olive
  { bg: '#D6E4F0', border: '#9BB8D6' },  // sky blue
  { bg: '#F0E0D0', border: '#D9B99A' },  // clay light
  { bg: '#E8E0F0', border: '#C4B3D9' },  // soft lavender
  { bg: '#F5EACC', border: '#E0CFA0' },  // wheat/gold
  { bg: '#DDE8E0', border: '#AAC5B3' },  // eucalyptus
  { bg: '#F2E0E0', border: '#D9AAAA' },  // rose clay
  { bg: '#E8E4D4', border: '#C9C1A8' },  // limestone
];

export function shuffleColors(count) {
  const pool = [...PASTEL_COLORS];
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  const colors = [];
  for (let i = 0; i < count; i++) {
    colors.push(pool[i % pool.length]);
  }
  return colors;
}

export function pastelStyle(color) {
  return {
    background: `linear-gradient(145deg, #FEFCF7 0%, ${color.bg} 100%)`,
    borderColor: color.border,
  };
}

export function pastelChosenStyle(color) {
  return {
    background: `linear-gradient(145deg, ${color.bg} 0%, ${color.border} 100%)`,
    borderColor: color.border,
  };
}
